enum SampleEventsEnum {
  RemoveCartEntry = 'RemoveCartEntry',
  UpdateCartEntryQty = 'UpdateCartEntryQty',
  AddToCart = 'AddToCart',
}
export default SampleEventsEnum;

import {
  PlanRequest,
  ProfileRequest,
  SubscriptionRequest,
  UpdatePlanRequest,
  UpdateProfileRequest,
  UpdateSubscriptionRequest,
  UpdateSubscriptionElement,
  SubscriptionType,
} from '../../services/models';

export interface ProductPlanDetailsAPI {
  productId: string;
  projections?: string;
}

export interface GetProfileAPI {
  profileId: string;
  productId?: string;
  projections?: string;
}

export interface CreateProfileAPI {
  payload: ProfileRequest;
  projections?: string;
}

export interface UpdateProfileAPI {
  profileId: string;
  projections?: string;
  payload: UpdateProfileRequest;
}

export interface PlanDetailsAPI {
  planId: string;
  projections?: string;
}

export interface PlanCodeDetailsAPI {
  planCodes: string;
  projections?: string;
}

export interface GetSubscriptionAPI {
  subscriptionId: string;
  projections?: string;
}

export interface CreateSubscriptionAPI {
  payload: SubscriptionRequest;
  projections?: string;
}

export interface UpdateSubscriptionAPI {
  subscriptionId: string;
  payload: UpdateSubscriptionRequest;
  projections?: string;
}

export interface SubscriptionsAPI {
  projections?: string;
  accountId?: string;
  page?: string;
  filter?: string;
  headerObj?: {};
}

export interface SubscriptionProfileListAPI {
  accountId: string;
  projections?: string;
  type?: SubscriptionType;
  userProfileId?: string;
  page?: string;
  limit?: string;
}

export interface CancelSubscriptionAPI {
  subscriptionId: string;
  payload: UpdateSubscriptionRequest;
  projections?: string;
}

export interface GetProfilePaymentDays {
  profileId: string;
  projections?: string;
}

export interface GetPlanCyclesAPI {
  projections?: string;
}

export interface CreatePlanAPI {
  projections?: string;
  payload: PlanRequest;
}

export interface UpdatePlanAPI {
  projections?: string;
  planId: string;
  payload: UpdatePlanRequest;
}

export interface GetPlansAPI {
  page: string;
  projections?: string;
  productId?: string;
  codes?: string;
  filter?: string;
}

export interface GetElementsAPI {
  subscriptionId: string;
  projections?: string;
}

export interface UpdateElementsAPI {
  projections?: string;
  elementId: string;
  payload: UpdateSubscriptionElement;
}

export enum PlanResponseTypeEnum {
  Benefit = 'BENEFIT',
  Ditto = 'DITTO',
  SOP = 'SOP',
  GMN = 'GMN',
}
